import React from 'react'
import TripRequestManager from '../components/trips/TripRequestManager'
import { useParams } from 'react-router-dom';

const TripRequestManagerPage = () => {
  const { tripId } = useParams<{ tripId: string }>();
    if (!tripId) {
        return <div className="text-center py-8">
        <p className="text-gray-500">No trip ID provided</p>
        </div>
    }

  return (
    <TripRequestManager tripId={Number(tripId)} />
  )
}

export default TripRequestManagerPage